<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <NexmoSmsForm
            v-if="isNexmoSms"
            :action="storeThirdPartyService"
            @cancel="$refs.modal.close()"
          />
          <MailSmtpForm
            v-else-if="isCustomEmail"
            :action="storeThirdPartyService"
            @cancel="$refs.modal.close()"
          />
          <div v-else>Cannot handle {{ this.service }}/{{ this.channel }}</div>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import NexmoSmsForm from './NexmoSmsForm.vue';
import MailSmtpForm from './MailSmtpForm.vue';

export default {
  components: {
    NexmoSmsForm,
    MailSmtpForm,
    BaseCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    service: {
      type: String,
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
  },
  computed: {
    isNexmoSms() {
      return this.service === 'vonage' && this.channel === 'sms';
    },
    isCustomEmail() {
      return this.service === 'custom email' && this.channel === 'mail';
    },
  },
  methods: {
    async storeThirdPartyService(inputData) {
      try {
        await this.$store.dispatch('ui/accountThirdPartyServices/store', {
          accountId: this.accountId,
          formData: {
            ...inputData,
            active: true,
            service: this.service,
            channel: this.channel,
          },
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
